import { Result } from 'src_common/common/mobx-utils/Form2/FormModel';

export const parseNumeric = (numeric: string): number => {
    if (/^\d+(\.\d+)?$/.test(numeric.trim())) {
        return parseFloat(numeric);
    }
    return NaN;
};

/**
 * Parse numeric string to number
 * @param optional - if true, empty string is valid
 * @param message - error message
 * @param value - array parsed to string
 */
export const isNumeric =
    (optional: boolean, message: string) =>
    (value: string): Result<string> => {
        if (optional === true && value === '') {
            return Result.createOk(value);
        }

        const numberValue = parseNumeric(value);
        if (isNaN(numberValue)) {
            return Result.createError(message);
        }
        return Result.createOk(value);
    };
